import React, { useState, useCallback } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { Background } from 'LocalGluons';
import { t } from 'Locale';

import CancelableTextInput from 'LocalGluons/components/CancelableTextInput';
import favoritesInputProps from 'Pages/FavoriteSettings/utils/favoritesInputProps';
import { FavoritePageWrapper } from '../FavoritePageWrapper';

import favoritesSettingsStyles from '../../FavoritesSettings.jss';
import { ChannelFavoriteFilterList } from '../../components/ChannelFavoriteFilterList';
import { navigationStyles } from '../../../../Navigation/navigationOptions';
import { useFavoriteSettingsContext } from '../../FavoriteSettingsContext';

const PackageFavorite = ({ navigation, route }) => {
    const { activeCategory, onSaveCallback, onCancelCallback } = route.params;
    const { orderedFavoriteList, setOrderedFavoriteList, channelMap } =
        useFavoriteSettingsContext();
    const [query, setQuery] = useState('');

    const onChangeSearchTextCallback = useCallback((text) => setQuery(text.toLowerCase()), []);

    return (
        <Background>
            <FavoritePageWrapper
                onSaveCallback={onSaveCallback}
                onCancelCallback={onCancelCallback}
            >
                <>
                    <View style={favoritesSettingsStyles.searchMarginContainer}>
                        <CancelableTextInput
                            {...{
                                ...favoritesInputProps,
                                containerStyle: favoritesSettingsStyles.searchInputContainer,
                                placeholder: t('SETTINGS.FAVOURITE_CHANNELS_SEARCH'),
                                onChangeText: onChangeSearchTextCallback,
                                displayCancelIcon: Boolean(query),
                                onCancel: (inputRef) => {
                                    setQuery('');
                                    inputRef.clear();
                                }
                            }}
                        />
                    </View>
                    <ChannelFavoriteFilterList
                        channelIds={activeCategory.channelIds}
                        channelMap={channelMap}
                        orderedFavoriteList={orderedFavoriteList}
                        setOrderedFavoriteList={setOrderedFavoriteList}
                        query={query}
                    />
                </>
            </FavoritePageWrapper>
        </Background>
    );
};

PackageFavorite.propTypes = {
    navigation: PropTypes.shape({
        getParam: PropTypes.func,
        state: PropTypes.shape({
            params: PropTypes.shape({
                activeCategory: PropTypes.shape({}),
                orderedFavoriteList: PropTypes.arrayOf(PropTypes.number),
                setOrderedFavoriteList: PropTypes.func,
                channelMap: PropTypes.shape({}),
                onSaveCallback: PropTypes.func,
                onCancelCallback: PropTypes.func
            })
        })
    }).isRequired
};

export { PackageFavorite };
